import { baseFields, FormModel, onlineFlags } from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'perceivedValue',
    ...onlineFlags,
    'hiddenMenuKey',
    'hiddenMenuName',
    'images',
  ]
}
